import { Link } from '@tanstack/router'
import AutoScroll from 'embla-carousel-auto-scroll'
import useEmblaCarousel from 'embla-carousel-react'
import { useTranslation } from 'react-i18next'
import { LazyLoadComponent } from 'react-lazy-load-image-component'

import sevenEleven from '../../assets/footer/7eleven.webp'
import banorte from '../../assets/footer/banorte.webp'
import bbva from '../../assets/footer/bbva.webp'
import benavides from '../../assets/footer/benavides.webp'
import bodegaaurrera from '../../assets/footer/bodegaaurrera.webp'
import calimax from '../../assets/footer/calimax.webp'
import cash from '../../assets/footer/cash.webp'
import casino_logo from '../../assets/footer/casino_logo.webp'
import circulok from '../../assets/footer/circulok.webp'
import extra from '../../assets/footer/extra.webp'
import farmaciadelahorro from '../../assets/footer/farmaciadelahorro.webp'
import farmaciaroma from '../../assets/footer/farmaciaroma.webp'
import lacomer from '../../assets/footer/lacomer.webp'
import mastercard from '../../assets/footer/mastercard.webp'
import mexplay_logo from '../../assets/footer/mexplay_logo.webp'
import oxxo from '../../assets/footer/oxxo.webp'
import paynet from '../../assets/footer/paynet.webp'
import sams from '../../assets/footer/sams.webp'
import santamaria from '../../assets/footer/santamaria.webp'
import soriana from '../../assets/footer/soriana.webp'
import spei from '../../assets/footer/spei.webp'
import sports_logo from '../../assets/footer/sports_logo.webp'
import ssl from '../../assets/footer/ssl.webp'
import stp from '../../assets/footer/stp.webp'
import teleingreso from '../../assets/footer/teleingreso.webp'
import visa from '../../assets/footer/visa.webp'
import walmart from '../../assets/footer/walmart.webp'
import { useBoundStore } from '../../store/store'
import classNames from '../../utils/classNames'
import Icon from '../icon'

const PAYMENT_LOGOS = [
  spei,
  oxxo,
  mastercard,
  visa,
  sevenEleven,
  banorte,
  bbva,
  benavides,
  bodegaaurrera,
  calimax,
  cash,
  circulok,
  extra,
  farmaciadelahorro,
  farmaciaroma,
  lacomer,
  paynet,
  sams,
  santamaria,
  soriana,
  stp,
  teleingreso,
  walmart,
] as const

const PaymentLogos = () => {
  const [emblaRef] = useEmblaCarousel(
    { loop: true, align: 'start', skipSnaps: true },
    [
      AutoScroll({
        speed: 1,
      }),
    ],
  )

  return (
    <div className="px-0 py-9 border-b border-solid border-b-[#0e091e] dark:border-b-[#959595] xl:pl-[30px] xl:pr-10 xl:py-10">
      <div className="embla" ref={emblaRef}>
        <div className="embla__container">
          {PAYMENT_LOGOS.map((logo, index) => (
            <div
              key={index}
              className="w-[90px] flex-[0_0_auto] justify-center items-center h-[50px] px-3 py-0">
              <img className="max-w-full max-h-full" src={logo} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

const Sponsors = () => {
  const pending_bind = useBoundStore(state => state.user.pending_bind)
  const setIsPendingDepositVisible = useBoundStore(
    state => state.common.setIsPendingDepositVisible,
  )
  const { t } = useTranslation(['drawer', 'common'])

  return (
    <LazyLoadComponent>
      <div className="mb-10 px-5 py-0 xl:mb-[50px] xl:p-0">
        <div
          className={classNames(
            'pt-10 pb-0 px-0 border-t border-solid border-t-[#0e091e] dark:border-t-[#959595]',
            'xl:flex xl:justify-between xl:items-start xl:w-full xl:pt-10 xl:pb-0 xl:px-10',
          )}>
          <div className="flex flex-wrap gap-[30px] justify-around items-center mb-9 xl:flex-nowrap xl:mb-0">
            <Link className="relative" to="/">
              <img
                className="invert-[97%] dark:invert-[0%] w-[109px] scale-[1.2]"
                src={mexplay_logo}
              />
              <span
                className={classNames(
                  'font-Syncopate-Bold w-[150px] text-center absolute -translate-x-2/4',
                  'uppercase text-[7px] text-txt tracking-[1px] left-2/4 -bottom-2.5',
                )}>
                CASINO ONLINE
              </span>
            </Link>
            <Link
              className="relative"
              to={
                +pending_bind === 0 || +pending_bind === 2
                  ? undefined
                  : '/sports'
              }
              onClick={() => {
                if (+pending_bind === 0 || +pending_bind === 2)
                  setIsPendingDepositVisible(true)
              }}>
              <img
                className="invert-[97%] dark:invert-[0%]"
                src={sports_logo}
                style={{ width: 129.33 }}
              />
              <span
                className={classNames(
                  'font-Syncopate-Bold w-[150px] text-center absolute -translate-x-2/4',
                  'uppercase text-[7px] text-txt tracking-[1px] left-2/4 -bottom-2.5',
                )}>
                {t('sports')}
              </span>
            </Link>
            <Link
              className="relative"
              to="/casino/$category"
              params={{ category: 'lobby' }}>
              <img
                className="invert-[97%] dark:invert-[0%]"
                src={casino_logo}
                style={{ width: 108.88 }}
              />
              <span
                className={classNames(
                  'font-Syncopate-Bold w-[150px] text-center absolute -translate-x-2/4',
                  'uppercase text-[7px] text-txt tracking-[1px] left-2/4 -bottom-2.5',
                )}>
                {t('casino')}
              </span>
            </Link>
            <Link className="relative" to="/promotions">
              <div className="font-Geometr706-BlkCn-BT w-full text-center text-xl text-txt block uppercase xl:w-max">
                {t('promotions')}
              </div>
            </Link>
          </div>
          <div>
            <div className="flx-ctr gap-8 flex-wrap xl:gap-[14px_20px] xl:p-0">
              <img
                className="invert dark:invert-[0%]"
                src={ssl}
                alt="SSL"
                style={{ width: 136, filter: 'unset' }}
              />
            </div>
            <div className="flx-ctr gap-3 mt-6 xl:hidden">
              <div className="flex">
                <Icon
                  className="fill-txt"
                  id="18-plus"
                  width="38"
                  height="38"
                />
              </div>
              <p className="text-txt text-sm xl:text-base">
                {t('common:18-plus')}
              </p>
            </div>
          </div>
        </div>
        <PaymentLogos />
      </div>
    </LazyLoadComponent>
  )
}

export default Sponsors
